import React from "react"
import { T } from "../../traks"
import { Col, Row } from "reactstrap"

export const PremiumGuide = () => {
    return (
        <React.Fragment>
            <Row className='mt-4'>
                <h2 className='p-4'><T>This is how you do it</T></h2>
            </Row>
            
            <Row className='mt-2'>
                <Col sm="6">
                    <img src='https://static.aktiedysten.dk/imgs/premium-image-0.png' style={{width: "100%"}} alt='premium'/>
                </Col>
                <Col>
                    <Row>
                        <b className='pink-text'>1.&nbsp;</b> <b><T>Select a time period</T></b>
                    </Row>
                    <Row>
                        <T>Select how long you would like to have access to the premium benefits below.</T>
                    </Row>
                    <Row className='mt-3'>
                        <b className='pink-text'>2.&nbsp;</b> <b><T>How many do you want to invite</T></b>
                    </Row>
                    <Row>
                        <T>Choose the number of participants you would like to invite to your game(s). The invitations are not personal, which means you can transfer a key from one player to another if you wish.</T>
                    </Row>
                    <Row className='mt-3'>
                        <b className='pink-text'>3.&nbsp;</b> <b><T>You can now create premium games</T></b>
                    </Row>
                    <Row>
                        <T>Once we have received your upgrade request, we will process it as quickly as possible. Normally, your upgrade will be approved within 24 hours. After that, you can start your premium game.</T>
                    </Row>
                </Col>
            </Row>
            </React.Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/c/Premium/PremiumGuide.js